import React from 'react';
import './App.css';
import AppRoutes from './routes/AppRoutes';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react'; // Import PersistGate
import { SelectedOptionsProvider } from './context/SingleFlightContextProvider';
import { store, persistor } from './Redux/Store/Store';

function App() {
  return (
    <Provider store={store}>
      <PersistGate l persistor={persistor}>
        <SelectedOptionsProvider>
          <div className="App">
            <AppRoutes />
          </div>
        </SelectedOptionsProvider>
      </PersistGate>
    </Provider>
  );
}

export default App;
